class DetailsAccordion extends HTMLElement {
  constructor() {
    super();

    this.buttonEl = this.querySelector('button[data-expanded]');
    const controlsId = this.buttonEl.getAttribute('aria-controls');
    this.contentEl = this.querySelector(`#${controlsId}`);

    this.isOpen = this.buttonEl.getAttribute('data-expanded') === 'true';
  }

  connectedCallback() {
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.isOpen);
  }

  toggle(open) {
    if (open === this.isOpen) {
      return;
    }

    this.isOpen = open;

    this.buttonEl.setAttribute('data-expanded', `${open}`);

    if (open) {
      this.setAttribute('open', '');
    } else {
      this.removeAttribute('open');
    }
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }
}

customElements.define('details-accordion', DetailsAccordion);
